import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { reduxForm, Field, change, formValueSelector } from 'redux-form'
import Image from 'react-image'
import LoadImage from 'assets/images/loading-image.gif'
import NewFile from 'assets/images/new-file-simple-md.png'
import ThumbnailLoader from 'components/shared/loaders/thumb'
import * as types from 'actions/messages/types'
import Attachement from 'forms/shared/fields/attachment'

const MessageBox = ({
  id,
  handleSubmit,
  onSubmit,
  reset,
  conversationTyping,
  isAdmin,
  status,
  form,
  attachment,
  dispatch,
  conversationBlur,
  typingName,
  typingId,
  handleMessageOrProposal,
  proposalDetail,
  client,
  inquiryId,
  spaceId,
}) => {
  const action = proposalDetail ? 'edit-proposal' : 'send-proposal'
  const msgField = useRef()
  const handleClick = () => {
    const proposalId = proposalDetail ? proposalDetail.proposal_id : null
    const data = {
      clientId: client.id,
      closeTitle: `Back to Messages with ${client.name}`,
      action,
      spaceId,
    }
    data.id = proposalDetail ? proposalId : inquiryId
    handleMessageOrProposal(data)
  }
  const handleChange = (value) => {
    if (value) {
      conversationTyping({ id, typingName, typingId })
    } else {
      conversationBlur({ typingId })
    }
  }
  const handleRemoveAttachment = (index) => {
    const newAttachment = attachment
    newAttachment.splice(index, 1)
    dispatch(change(form, 'attachment', newAttachment))
  }
  const editProposalStatus = ['pending payment', 'proposal sent']
  return (
    <>
      {!isAdmin && (
        <div className="border p-5 text-white shadow block">
          {editProposalStatus.includes(status) && (
            <span
              className="cursor-pointer text-orange-500 text-sm font-medium"
              onClick={() => handleClick()}
            >
              VIEW/EDIT PROPOSAL
            </span>
          )}
          {status === 'accepted' && (
            <p className="text-primary-black text-sm">
              NEXT STEP:
              <span
                className="cursor-pointer text-orange-500 text-sm font-medium ml-2"
                onClick={() => handleClick()}
              >
                Type your reply. You may then SEND PROPOSAL
              </span>
            </p>
          )}
        </div>
      )}
      {attachment.length > 0 && (
        <div className="attachment w-full max-h-max flex-wrap border flex">
          {attachment.map((file, key) => {
            const isImage = !file.type || file.type.indexOf('image') > -1
            return (
              <div className="h-48 w-48 p-2 flex flex-col items-center" key={key}>
                <div className="w-max max-h-max p-3 border border-dashed rounded relative">
                  {isImage && (
                    <Image
                      src={[file.path, LoadImage]}
                      alt={file.name}
                      className="h-32 w-32 object-cover rounded"
                      loader={<ThumbnailLoader />}
                    />
                  )}
                  {!isImage && (
                    <Image
                      src={file.path ? NewFile : LoadImage}
                      alt={file.name}
                      className={`h-32 ${file.path ? 'w-auto' : 'w-32'} object-cover rounded`}
                      loader={<ThumbnailLoader />}
                    />
                  )}
                  <div className="absolute right-0 top-0 leading-none">
                    <i
                      onClick={() => handleRemoveAttachment(key)}
                      className="fa fa-minus-circle text-xl cursor-pointer text-red-600"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
                <div className="w-full truncate text-xs text-center text-primary-darkgray">
                  {file.name}
                </div>
              </div>
            )
          })}
        </div>
      )}
      <form
        onSubmit={handleSubmit((values) => {
          onSubmit(values)
          reset()
        })}
        name="send-message-form"
      >
        <div className="flex items-center">
          <Field
            ref={msgField}
            onBlur={() => conversationBlur({ typingId })}
            onChange={(e) => handleChange(e.target.value)}
            placeholder="Type your reply here..."
            name="message"
            rows="4"
            className="auto-size focus:outline-none focus:bg-white bg-gray-100 border p-1 w-full px-5 py-3 message-box-area"
            component="textarea"
          />
        </div>
        <div className="flex items-center justify-between p-5">
          <Field
            formName={form}
            name="attachment"
            type="file"
            label="ATTACH FILES"
            component={Attachement}
            acceptedFiles="image/jpg, image/jpeg, image/png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          />
          <button className="rounded bg-orange-400 text-white py-2 px-5 text-sm ml-2 font-medium">
            Send
          </button>
        </div>
      </form>
    </>
  )
}

MessageBox.propTypes = {
  onSubmit: PropTypes.func,
  handleSubmit: PropTypes.func,
  messages: PropTypes.array,
  form: PropTypes.string,
  reset: PropTypes.func,
  typingName: PropTypes.string,
  typingId: PropTypes.number,
  conversationBlur: PropTypes.func,
  conversationTyping: PropTypes.func,
  id: PropTypes.number,
  handleMessageOrProposal: PropTypes.func,
  proposalDetail: PropTypes.object,
  client: PropTypes.object,
  inquiryId: PropTypes.number,
  isAdmin: PropTypes.bool,
  spaceId: PropTypes.number,
  status: PropTypes.string,
  attachment: PropTypes.array,
  dispatch: PropTypes.func,
}

const mapStateToProps = ({ ...state }, { form }) => {
  const selector = formValueSelector(form)
  return {
    attachment: selector(state, 'attachment') || [],
  }
}

const mapDispatchToProps = (dispatch) => ({
  conversationTyping: (payload) => dispatch({ type: types.CONVERSATION_TYPING, payload }),
  conversationBlur: (payload) => dispatch({ type: types.CONVERSATION_BLUR, payload }),
  dispatch,
})

export default reduxForm({})(connect(mapStateToProps, mapDispatchToProps)(MessageBox))
